const style = {
  disabledContent: {
    backgroundColor: 'rgba(255, 255, 255, .9)',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    zIndex: 1,
    borderRadius: 8
  },
  loadingContainer: {
    position: 'absolute',
    right: '50%',
    bottom: '50%',
    transform: 'translate(50%, 50%)',
    zIndex: 1
  }
};

export default style;
